import { useState, useEffect, ReactElement, useRef } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

import { modalStore } from '../../stores';

interface props {
  id: string,
  className?: string,
  onClose?: () => void,
  onOpen?: () => void,
  disableFooter?: boolean,
  children?: ReactElement<any, any> | ReactElement<any, any>[],
}

const Modal = (({ id, onClose, onOpen, children }: props) => {
  const [isOpen, setIsOpen] = useState(false);
  const init = useRef(false);

  useEffect(() => {
    if (!init.current) {
      init.current = true;
      return;
    }

    if (isOpen && onOpen !== undefined) {
      onOpen();
    }

    if (!isOpen && onClose !== undefined) {
      onClose();
    }
  }, [isOpen]);

  useEffect(() => {
    modalStore.registerModal({
      id,
      cb: (isOpen: boolean) => {
        setIsOpen(isOpen);
      }
    });

    return () => {
      modalStore.unregisterModal(id);
    };
  }, [id]);

  const onOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <Dialog.Content className="DialogContent">
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
});

export default Modal;





